import { useState } from 'react'
import './index.scss'
import { DadosDaEmpresa } from './pages/dados-da-empresa';
import { Socios } from './pages/socios';
import { Regulatorio } from './pages/regulatorio';
import { Documentacao } from './pages/documentacao';
import { StatusCadastro } from './pages/status-cadastro';
import { SeusDados } from './pages/seus-dados';
import { Link } from 'react-router-dom';
import { Icon } from '../../components/icon';
import Arrow from "../../assets/icons/arrow-right.svg"
export const AberturaConta = ({type}) => {

    const maxStep = type === 0? 4 : 1

    const [step, setStep] = useState(
        localStorage.getItem("step") !== undefined && localStorage.getItem("step") != null?
         parseInt(localStorage.getItem("step")) 
         : 
         1
    );
    const [stepProcess, setStepProces] = useState(
        (localStorage.getItem("step") !== undefined && localStorage.getItem("step") != null)? 
        parseInt(localStorage.getItem("step")) >= maxStep ? 
            false 
            : 
            true 
        : 
        true)

    const nextStep = () => {
        if(step < maxStep) {
            setStep(step + 1)
            localStorage.setItem("step", step+1)
        }
        else setStepProces(false)
    }

    const prevStep = () => {
        setStep(step - 1)
        localStorage.setItem("step", step-1)

    }

    const pagesPJ = [
        {name: "Dados da empresa", element: <DadosDaEmpresa nextStep={nextStep} />},
        {name: "Sócios", element: <Socios nextStep={nextStep} prevStep={prevStep}/>},
        {name: "Regulatório", element: <Regulatorio nextStep={nextStep} prevStep={prevStep}/>},
        {name: "Documentação", element: <Documentacao nextStep={nextStep} prevStep={prevStep}/>}
    ]

    const pagesPF = [
        {name: "Seus Dados", element: <SeusDados nextStep={nextStep} />},
    ]

    const pages = type === 0 ? pagesPJ : pagesPF

   
    

   


    return(
        <div className='conta-container'>
            <div className='step-menu'>
                <div>
                    <span style={{display:"flex", flexDirection:"row", gap:5, alignItems:"start", paddingBottom:'10px'}}>
                        <Icon icon={Arrow} size={10} rotation={180} style={{marginTop:"-2px"}} />
                        <Link to="/" style={{textDecoration:"none", color:"white", fontSize:"14px"}} onClick={() => {
                            localStorage.clear()
                        }}>Voltar para Home</Link>
                    </span>
                    <div className='header'>
                        <span className='title'>Abertura de conta</span>
                        <span className='subtitle'>Pessoa {type === 0 ? "Jurídica" : "Física"}</span>
                    </div>

                    <div className='steps'>
                        {pages.map((page, key) => {
                            return(
                                <div className={`step-nav ${(key+1 < step || ((key+1 === step) && !stepProcess))? "done" : key+1 === step? "active" : ""}`}>
                                    <span className='page-number'>{key + 1}</span>
                                    <span className='page-name'>{page.name}</span>
                                </div>
                            )
                        })}
                    </div>
                </div>
            </div>
            {stepProcess ?  
            <>{pages[step-1].element}</>
            :
            <StatusCadastro/>
            } 
            
        </div>
    )
}